module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcAQMAAABIw03XAAAAA1BMVEUAAACnej3aAAAAC0lEQVQI12MYRAAAAIwAAY77X9AAAAAASUVORK5CYII="